"use client"

import { useEffect } from "react"
import { RefreshCw, Home, Send } from "lucide-react"
import { CellSignalX } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error("Application error:", error)
  }, [error])

  const handleSendToSupport = () => {
    const subject = encodeURIComponent("Error Report — Algoglide")
    const body = encodeURIComponent(
      [
        `Error: ${error?.message ?? "Unknown error"}`,
        ``,
        `Stack trace:`,
        `${error?.stack ?? "No stack trace available"}`,
        ``,
        `---`,
        `Page: ${typeof window !== "undefined" ? window.location.href : "Unknown"}`,
        `Time: ${new Date().toISOString()}`,
        error?.digest ? `Digest: ${error.digest}` : "",
      ]
        .filter(Boolean)
        .join("\n")
    )
    window.location.href = `mailto:support@algoglide.com?subject=${subject}&body=${body}`
  }

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="flex flex-col items-center text-center gap-3">
        {/* Icon — matching the trading chart error pattern */}
        <CellSignalX
          size={80}
          weight="thin"
          className="text-muted-foreground/40 mb-2"
        />

        <p className="text-sm text-muted-foreground">Unable to load page</p>

        {/* Action buttons */}
        <div className="flex items-center gap-2 mt-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => reset()}
            className="gap-2"
          >
            <RefreshCw className="h-3.5 w-3.5" />
            Try again
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => (window.location.href = "/")}
            className="gap-2"
          >
            <Home className="h-3.5 w-3.5" />
            Go home
          </Button>
        </div>

        {/* Send to support */}
        <button
          onClick={handleSendToSupport}
          className="flex items-center gap-1.5 text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground transition-colors mt-1"
        >
          <Send className="h-3 w-3" />
          Send issue to support
        </button>
      </div>
    </div>
  )
}
